import "pixi.js";
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require ("pixi-spine");
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {WinterHoardIntroConfig} from "./game/intro/WinterHoardIntroConfig";

import {WinterHoard} from "./game/WinterHoard";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {BuffaloHunterPromoPanelConfig} from "./game/BuffaloHunterTribePromoPanelConfig";



///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomEase.d.ts"/>
///<reference path="../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomWiggle.js");
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");


declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([ new WinterHoard(), new NolimitSlotAudio(), new SlotKeypad(), new NolimitPromotionPlugin(new BuffaloHunterPromoPanelConfig()), new  NolimitGameIntroPlugin(new WinterHoardIntroConfig())]);
